export default __webpack_public_path__ + "static/media/icon_column.07ed49a5.svg";